import React from 'react';
import agent from "../../../agent";
import ListView from "../../ListView/ListView";
import GameController from "../../../gameplay/controllers/GameController";

export default class GameSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentSave: null,
            currentEl: -1
        };
    }

    selectCurrentSave(elem, gameID) {
        this.setState({
            currentSave: gameID,
            currentEl: elem
        });
    }

    setSave() {
        agent.Game.setGameSave(this.props.gameId, this.state.currentSave, res => {
            if (res.status && res.status === "ok") {
                alert("Данные успешно обновлены!");
                this.props.onHide();
            }
        });
    }

    render() {
        const games = this.props.saves.map((el, i) => {
            return <div key={i} className={"select__game" + (this.state.currentEl === i ? " selected" : "")}
                        onClick={() => this.selectCurrentSave(i, el)}>
                {GameController.getSaveInfo(el)}
            </div>
        });

        return <ListView children={games} onSelect={this.setSave.bind(this)} onHide={this.props.onHide} disabled={!this.state.currentSave} />
    }
}
